import React from 'react';
import { motion } from 'framer-motion';
import { CountdownTimer } from './CountdownTimer';
import { PricingSection } from './PricingSection';
import { Lock, Zap, Shield } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-114">
      <div className="absolute inset-0 bg-gradient-to-b from-navy-900 via-navy-800 to-navy-900 z-0" data-id="element-115"></div>
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-full bg-gold-500/5 blur-[120px] rounded-full z-0 pointer-events-none" data-id="element-116"></div>

      <div className="relative z-10 max-w-6xl mx-auto" data-id="element-117">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-118">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-119">
            La próxima noche puede ser diferente.
          </h2>
        </motion.div>

        <CountdownTimer data-id="element-120" />

        <PricingSection data-id="element-121" />

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-16 flex flex-wrap justify-center gap-6 md:gap-12 text-sm md:text-base font-medium text-blue-200/80" data-id="element-122">
          <div className="flex items-center gap-2" data-id="element-123">
            <Lock className="w-5 h-5 text-gold-400/70" data-id="element-124" /> Pago 100% seguro
          </div>
          <div className="flex items-center gap-2" data-id="element-125">
            <Zap className="w-5 h-5 text-gold-400/70" data-id="element-126" /> Acceso en 5 minutos
          </div>
          <div className="flex items-center gap-2" data-id="element-127">
            <Shield className="w-5 h-5 text-gold-400/70" data-id="element-128" /> Garantía 7 días
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="mt-6 text-center text-sm text-blue-200/50" data-id="element-129">
          💳 Mercado Pago | Tarjeta | Transferencia
        </motion.div>
      </div>
    </section>;
}